import React, { useState, useEffect, cloneElement } from 'react';
import {
    List, Datagrid, TextField, Create, SimpleForm, TextInput, ReferenceInput, SelectInput, EditButton, SimpleList,
    Edit, Toolbar, SaveButton, BooleanInput, useInput, useGetOne, ArrayInput, SimpleFormIterator, TopToolbar, sanitizeListRestProps, useListContext, useRedirect
} from 'react-admin';
import { Typography, withStyles, TextField as MuiTextField, Checkbox, LinearProgress, useMediaQuery, makeStyles } from '@material-ui/core';
import featureData from './features.json';
import { vehicleSvgs } from "./sharedData";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import notify from './components/CustomUseNotify';

const useStyles = makeStyles({
    editNoActions: {
        marginTop: 0
    }
});
export const ParkingLedList = props => {
    const location = useLocation();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let searchTypeState = ["Parking Name"]
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Parking Name");
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let filter = { parking_name: search ? search : undefined }


    const ParkingLedActions = (props) => {

        const {
            className,
            exporter,
            filters,
            maxResults,
            ...rest
        } = props;

        const {
            resource,
            displayedFilters,
            filterValues,
            showFilter,
            total,
            page,
            setPage,
            perPage,
            setPerPage,
            hasPreviousPage,
            hasNextPage
        } = useListContext();


        return (
            <TopToolbar {...sanitizeListRestProps(rest)} style={{ display: "block", marginTop: "22px" }}>
                {filters && cloneElement(filters, {
                    resource,
                    showFilter,
                    displayedFilters,
                    filterValues,
                    context: 'button',
                })}
                {total !== 0 && <CustomPagination setPage={setPage} page={page} total={total} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} perPage={perPage} setPerPage={setPerPage} />}
                {/* {isSmallDevice && <div style={{ display: "flex", justifyContent: "flex-start" }}>
                    <div className='showResultTime' style={{ position: 'static', marginRight: 36 }}>
                        <p>Showing Results: Today 00:01am To Today {moment().format('LT')}</p>
                    </div>
                </div>} */}
            </TopToolbar>
        )
    };

    return <div>
        {showFilter && <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />}

        <List
            {...props}
            title="Parking LEDs"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            // filters={!isSmallDevice && <Filter id="filterInputGrid">
            //     <div className='showResultTime' alwaysOn style={{ minWidth: isSmallDevice ? 0 : 400 }}>
            //         <p>Showing Results: Today 00:01am To Today {moment().format('LT')}</p>
            //     </div>
            // </Filter>}
            sort={{ field: 'led_id', order: 'ASC' }}
            empty={false}
            actions={<ParkingLedActions />}
            pagination={<CustomPagination />}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => <div style={{ paddingRight: 24 }}>LED ID: {record.led_id}</div>}
                    secondaryText={record => (<div style={{ paddingRight: 24 }}>
                        {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                        {record.header_text && record.header_text.trim() !== "" ? <div><span style={{ color: "#5a5a5a" }}>Header Text: </span>{record.header_text}</div> : ""}
                    </div>)}
                    rightIcon={record => <div style={{ position: "relative", right: -17 }}><EditButton {...props} record={record} label="Settings" /></div>}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid >
                    <TextField label="LED ID" source="led_id" />
                    <TextField label="Parking Name" source="parking_name" />
                    <TextField label="Header Text" source="header_text" />
                    <EditButton label="Settings" />
                </Datagrid>
            }
        </List>
    </div>
};

const CustomVehicleTypes = props => {
    const { input: { value: vehicles_visible, onChange: setVehiclesVisible } } = useInput({ ...props, id: "vehicles_visible", source: "vehicles_visible" });
    const { input: { value: vehicles_text, onChange: setVehiclesText } } = useInput({ ...props, id: "vehicles_text", source: "vehicles_text" });
    const { input: { value: vehicles_max_count, onChange: setVehiclesMaxCount } } = useInput({ ...props, id: "vehicles_max_count", source: "vehicles_max_count" });

    const [value, onChange] = useState(featureData.vehicle_type);
    const updateProperty = (key, params) => {
        const data = { ...value };
        data[key] = { maxCount: 0, ...data[key], ...params };
        onChange(data);
    };

    const updateMaxCount = (key, maxCount) => {
        if (isNaN(maxCount))
            return;
        updateProperty(key, { maxCount });
    };

    React.useEffect(() => {
        const data = { ...value };
        const vehiclesVisible = vehicles_visible.split(",");
        const vehiclesText = vehicles_text.split(",");
        const vehiclesMaxCount = vehicles_max_count.split(",");
        for (let i in vehiclesVisible) {
            data[vehiclesVisible[i]] = {
                checked: true,
                label: vehiclesText[i],
                maxCount: vehiclesMaxCount[i]
            };
        }
        onChange(data);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        const vehiclesVisible = [];
        const vehiclesText = [];
        const vehiclesMaxCount = [];
        const keys = Object.keys(value);
        for (let i in keys) {
            if (value[keys[i]].checked) {
                vehiclesVisible.push(keys[i]);
                vehiclesText.push(value[keys[i]].label);
                vehiclesMaxCount.push(value[keys[i]].maxCount);
            }
        }
        setVehiclesVisible(vehiclesVisible.join(","));
        setVehiclesText(vehiclesText.join(","));
        setVehiclesMaxCount(vehiclesMaxCount.join(","));
    }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div style={{ display: "grid", gridRowGap: 20 }}>
            {Object.keys(value).map(key => (
                <div key={key} style={{ display: "grid", gridAutoFlow: "column", gridColumnGap: 10, justifyContent: "flex-start", alignItems: "center" }}>
                    <Checkbox
                        color="primary"
                        checked={value[key].checked ? value[key].checked : false}
                        onChange={e => updateProperty(key, { checked: e.target.checked })}
                    />
                    <MuiTextField
                        variant="outlined"
                        size="small"
                        placeholder="Text"
                        value={value[key].label}
                        onChange={e => updateProperty(key, { label: e.target.value.replace(/,/g, "") })}
                        disabled={!value[key].checked}
                    />
                    <MuiTextField
                        variant="outlined"
                        size="small"
                        placeholder="Max Count"
                        value={value[key].maxCount}
                        onChange={e => updateMaxCount(key, e.target.value)}
                        onBlur={e => updateMaxCount(key, parseInt(e.target.value !== "" ? e.target.value : "0"))}
                        disabled={!value[key].checked}
                    />
                    <img src={vehicleSvgs[key]} style={{ width: 30, height: 30, marginLeft: 10, overflow:"visible" }} alt={""} />
                </div>
            ))}
        </div>
    );
};

const CustomParkingSelector = props => {
    const { input: { value, onChange } } = useInput(props);
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [parking, setParking] = useState(null);
    const { data } = useGetOne('parkings', value);

    const onParkingChange = p => {
        onChange(p.id);
    };

    useEffect(() => {
        if (data != null)
            setParking(data);
    }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

    return (parking ?
        <ParkingSearchSelector
            value={parking}
            onChange={onParkingChange}
            style={{ width: isSmallDevice ? "100%" : "40%", minWidth: isSmallDevice ? 0 : 300, marginBottom: 25 }}
            label=""
            clearable={false}
            zones={true}
        />
        :
        <LinearProgress color="primary" style={{ marginBottom: 25 }} />
    );
};

export const ParkingLedEdit = (props) => {
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const classes = useStyles();

    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }

    return (
        <Edit {...props} onFailure={onFailure} onSuccess={onSuccess} title="Parking LED Settings" undoable={false} classes={{ noActions: classes.editNoActions }}>
            <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
                <TextField label="LED ID" source="led_id" style={{ fontSize: 21, position: "relative", bottom: 10 }} />

                <Typography style={{ marginBottom: 5 }}>Access Key</Typography>
                <CustomParkingSelector source="access_key_ids" />

                <Typography style={{ fontSize: 16 }}>Header</Typography>
                <div style={{ display: "grid", gridAutoFlow: "column", alignItems: "center", minWidth: isSmallDevice ? 0 : 550, width: isSmallDevice ? "100%" : "auto", gridColumnGap: 35 }}>
                    <TextInput label="Text" source="header_text" variant="outlined" />
                    <div>
                        <Typography style={{ fontSize: 15, color: "#555" }}>Moving</Typography>
                        <BooleanInput label="" source="header_is_moving" />
                    </div>
                </div>

                <Typography style={{ fontSize: 16 }}>Footer</Typography>
                <div style={{ display: "flex", columnGap: 20, alignItems: "center" }}>
                    <Typography style={{ fontSize: 15, color: "#555" }}>Moving</Typography>
                    <BooleanInput label="" source="footer_is_moving" style={{ position: "relative", top: 12 }} />
                </div>
                <Typography style={{ fontSize: 15, color: "#555" }}>Text</Typography>
                <ArrayInput label="" source="footer_text_array" variant="outlined" style={{ marginTop: 0, marginBottom: 40, position: "relative", top: -10 }}>
                    <SimpleFormIterator>
                        <TextInput label="" />
                    </SimpleFormIterator>
                </ArrayInput>

                <Typography style={{ marginBottom: 10 }}>Vehicle Types</Typography>
                <CustomVehicleTypes />
            </SimpleForm>
        </Edit>
    );
}

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

const CustomToolbar = withStyles(toolbarStyles)(props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
));

export const ParkingLedCreate = (props) => (
    <Create {...props} title="Create Operator App User">
        <SimpleForm>
            <TextInput source="username" />
            <TextInput source="password" type="password" />
            <TextInput source="confirm_password" type="password" label="Confirm Password" />
            <ReferenceInput label="Parking" source="access_key" reference="parkingAccessKeys" filter={{ zones: true }} perPage={1000}>
                <SelectInput source="access_key" optionText="name" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);